import React, { useEffect, useState } from 'react';
import moment from 'moment'
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete'
import { AccessControl } from '../../../components/Utils/AccessControl'
import { useConfirm } from 'material-ui-confirm'
import {
  CardHeader,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableContainer,
  TablePagination,
  Typography,
  Tooltip
} from '@mui/material'
import { OBRA_DIARIO_CONDICAO_CLIMATICA, MANUAIS_CATEGORIAS, STATUS_SERVICO, history } from '../../../utils'
import { authActions, obraDiarioAction } from '../../../_actions';
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter, } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { ObraDiarioAddModal } from './obraDiarioAddModal.component'
import { ObraDiarioModalEquipe } from './obraDiarioModalEquipe.component'
import { ObraDiarioModalAnexo } from './obraDiarioModalAnexo.component'
import CustomButton from '../../../components/CustomButton/CustomButton'
import { useDebounce } from 'use-debounce';
import HelpIcon from '@mui/icons-material/Help';
import { HelpModal } from '../../../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faUsers } from '@fortawesome/free-solid-svg-icons';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlgin: 'center'
  },
  nome: {
    marginTop: theme.spacing(1)
  },
  uploadButton: {
    marginRight: theme.spacing(2),
    justifyContent: 'center'
  },
  avatar: {
    height: 200,
    width: 200,
    borderRadius: '10px',
    webkitBorderRadius: '10px',
    mozBorderRadius: '10px',
    cursor: 'pointer'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
})

const ObraDiarioEdit = ({ props, idObra }) => {

  const { totalRegistros } = props.obraDiario
  const isLoadingObraDiario = props.obraDiario.isLoading
  const confirm = useConfirm()

  const [anexos, setAnexos] = useState([]);
  const [equipe, setEquipe] = useState([]);

  const { obraDiario } = props.obraDiario

  const [modalDiario, setModalDiario] = useState(false);

  const toggleModalDiario = () => setModalDiario(!modalDiario);
  const { match: { params } } = props;

  const [modalHelp, setModalHelp] = useState(false);
  const toggleModalHelp = () => setModalHelp(!modalHelp);

  const handleOpenModalHelp = () => {
    toggleModalHelp();
  }

  const [modalAnexos, setModalAnexos] = useState(false);
  const toggleModalAnexos = () => setModalAnexos(!modalAnexos);

  const [modalEquipe, setModalEquipe] = useState(false);
  const toggleModalEquipe = () => setModalEquipe(!modalEquipe);

  const handleOpenModalAnexos = (n) => {
    setAnexos(n.obrasDiariosAnexos);
    toggleModalAnexos();
  }

  const handleOpenModalEquipe = (n) => {
    setEquipe(n.obrasDiariosEquipes);
    toggleModalEquipe();
  }

  const dispatch = useDispatch()

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('asc');

  const handleOpenModalDiario = () => {
    toggleModalDiario();
  }

  const handleDeleteDiario = (id) => {
    confirm({
      title: 'Você deseja excluir este diário de obra?',
      description: 'Essa operação é irreversível',
      confirmationText: 'Sim, excluir!',
      disabled: props.obraDiario.isLoading,
      confirmationText: props.obraDiario.isLoading ? 'Excluindo diário...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      dispatch(obraDiarioAction.deleteObraDiarioById(id, idObra))
    })
  }

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      let filterModel = {
        Page: page,
        IdObra: idObra,
        Limit: limit,
        Term: term,
        Order: order,
        Direction: direction
      };

      dispatch(obraDiarioAction.getObraDiario(filterModel))

    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenPdf = (obraDiario) => {
    history.push("/obraDiarioPrintPdf", { obraDiario: obraDiario });
  };

  function isWinner(obra) {
    const idEmpresa = authActions.isEmpresa() ? props.authentication?.user?.usuariosEmpresas[0]?.idEmpresa : 0

    return obra.obrasOrcamentos?.some(orcamento => orcamento.idEmpresa === idEmpresa && orcamento.status === 1);
  }

  function TitleText() {
    return (
      <Typography variant="h5">
        <b>{'Diário de Obra'}</b>
      </Typography>
    )
  }

  function SegHeader() {
    return <TitleText />
  }

  return (
    <>
      <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5, alignContent: 'center', marginTop: 3 }}>
        <Grid container style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Grid item lg={4} md={4} xl={4} xs={12}>
            <CardHeader
              subheader="Cadastrar ou excluir Diários de Obra"
              title={<SegHeader />}
            />
          </Grid>
          <Grid item lg={1} md={1} xl={1} xs={12}>
            <IconButton
              aria-label="Ajuda"
              component="a"
              onClick={() =>
                handleOpenModalHelp()
              }
              size="small"
            >
              <Tooltip title={'Ajuda'}>
                <Tooltip>
                  <HelpIcon sx={{ float: 'center', color: '#000' }} fontSize='medium' />
                </Tooltip>
              </Tooltip>
            </IconButton>
          </Grid>
          {/*       SÓ PODE ENVIAR SE É EMPRESA, E SE A OBRA ESTIVER EM EXECUÇÃO*/}
          {authActions.isEmpresa() &&
            //se a empresa for a vencedora do orçamento também
            isWinner(props.obra) &&
            props.obra.ultimoEvento == STATUS_SERVICO.ORCAMENTO_APROVADO
            ?
            <Grid item lg={12} md={12} xl={12} xs={12} align="right">
              <CustomButton
                size="small"
                variant="outlined"
                style={{ verticalAlign: 'middle' }}
                onClick={handleOpenModalDiario}
                endIcon={<AddBoxIcon />}
              >
                Cadastrar novo diário
              </CustomButton>
            </Grid>
            :
            null
          }
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid item lg={12} md={12} xl={12} xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow size="small" style={{ backgroundColor: '#f2f2f2' }}>
                  <TableCell size="small" align="center">
                    <strong>DATA</strong>
                  </TableCell>
                  <TableCell size="small" align="center">
                    <strong>CONDIÇÃO CLIMÁTICA</strong>
                  </TableCell>
                  <TableCell size="small" align="center">
                    <strong>RESPONSÁVEL TÉCNICO</strong>
                  </TableCell>
                  <TableCell size="small" align="center">
                    <strong>OBSERVAÇÕES</strong>
                  </TableCell>
                  <TableCell size="small" align="center">
                    <strong>AÇÕES</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {undefined !== obraDiario && obraDiario.length
                  ? obraDiario.map((n) => {
                    return (
                      <TableRow hover key={n.id}>
                        <TableCell component="th" scope="row" align="center" width="120px">
                          {n.data ? moment(n.data).format("DD/MM/YYYY") : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {n.condicaoClimatica ? n.condicaoClimatica == OBRA_DIARIO_CONDICAO_CLIMATICA.SOL ? 'SOL' : OBRA_DIARIO_CONDICAO_CLIMATICA.CHUVA ? 'CHUVA' :
                            OBRA_DIARIO_CONDICAO_CLIMATICA.NUBLADO ? 'NUBLADO' : '' : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {n.responsavelTecnico ? n.responsavelTecnico.toUpperCase() : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          {n.observacoes ? n.observacoes.toUpperCase() : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="center">
                          <AccessControl
                            rule={'obrasDiarios.delete'} //permissão necessária para acessar conteúdo
                            yes={() => (
                              <IconButton
                                aria-label="Delete"
                                onClick={() => handleDeleteDiario(n.id)}
                                size="small"
                                disabled={authActions.isEmpresa() && !isWinner(props.obra)}
                              >
                                <Tooltip title="Excluir">
                                  <DeleteIcon />
                                </Tooltip>
                              </IconButton>
                            )}
                          />
                          <IconButton
                            aria-label="Delete"
                            onClick={() => handleOpenPdf(n)}
                            size="small"
                          >
                            <Tooltip title="Gerar PDF">
                              <FontAwesomeIcon icon={faFilePdf} />
                            </Tooltip>
                          </IconButton>
                          <IconButton
                            aria-label="Exibir anexos"
                            onClick={() => handleOpenModalAnexos(n)}
                            size="small"
                          >
                            <Tooltip title="Exibir anexos">
                              <FontAwesomeIcon icon={faFile} />
                            </Tooltip>
                          </IconButton>
                          <IconButton
                            aria-label="Exibir equipe"
                            onClick={() => handleOpenModalEquipe(n)}
                            size="small"
                          >
                            <Tooltip title="Exibir equipe">
                              <FontAwesomeIcon icon={faUsers} />
                            </Tooltip>
                          </IconButton>
                        </TableCell>
                      </TableRow >
                    )
                  })
                  :
                  (
                    !isLoadingObraDiario ?
                      <TableRow>
                        <TableCell rowSpan={3} colSpan={5} align="center">Nenhum registro encontrado</TableCell>
                      </TableRow>
                      :
                      Array.apply(null, { length: 5 }).map((e, i) => (
                        <TableRow hover>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                        </TableRow>
                      ))
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={totalRegistros}
            page={page}
            labelRowsPerPage="Linhas por página"
            labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
            onPageChange={handleChangePage}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeLimit}
          />
        </Grid>
      </Grid >
      {
        (modalDiario ?
          <ObraDiarioAddModal toggle={toggleModalDiario} modal={modalDiario} props={props} idObra={idObra} />
          :
          null
        )
      }

      {
        (modalAnexos ?
          <ObraDiarioModalAnexo toggle={toggleModalAnexos} modal={modalAnexos} props={props} anexos={anexos} />
          :
          null
        )
      }

      {
        (modalEquipe ?
          <ObraDiarioModalEquipe toggle={toggleModalEquipe} modal={modalEquipe} props={props} equipe={equipe} />
          :
          null
        )
      }

      {
        (modalHelp ?
          <HelpModal
            toggle={toggleModalHelp}
            modal={modalHelp}
            props={props}
            tela={MANUAIS_CATEGORIAS.ABA_DIARIO_OBRA}
          />
          :
          null
        )
      }
    </>
  );
};

ObraDiarioEdit.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}

const connectedObraDiarioEditPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(ObraDiarioEdit))
)
export { connectedObraDiarioEditPage as ObraDiarioEdit }

export default ObraDiarioEdit;
